import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';
export const LOAD_AD_USER = '[AdUser] LOAD AD USER';
export const LOAD_AD_USER_SUCCESS = '[AdUser] LOAD AD USER Success';
export const LOAD_AD_USER_FAILED = '[AdUser] LOAD AD USER Failure';
export const LOAD_CURRENT_USER_SUCCESS = '[AdUser] LOAD CURRENT USER Success';
export class LoadAdUser {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_AD_USER;
    }
}
export class LoadAdUserSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_AD_USER_SUCCESS;
    }
}
export class LoadAdUserFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_AD_USER_FAILED;
    }
}
export class LoadCurrentUserSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_CURRENT_USER_SUCCESS;
    }
}
//# sourceMappingURL=ad-user.actions.js.map